import { eFontAsset, eSfxSprite, Game } from "../../../../Game";
import { TIMER } from "../../../Gameplay";
import { GameplayTimer } from "../../../GameplayTimer";
import { IFlashFxSettings } from "../../FlashFx";
import { HUD } from "../../HUD";



export class Time {
    private _remTimeEnt: pc.Entity;
    private _remTimeSec: number;

    /**
     * Nastaveni zablesku pri restartovani na poslednich checkpointu
     */
    private _flashSettings: IFlashFxSettings = {
        color: new pc.Color(1, 0, 0), alpha: 0.25, easeIn: pc.CubicOut, lenIn: 250, easeOut: pc.CubicOut, lenOut: 100,
    };

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.GraphNode) {
        // Vykresleni casu
        this._remTimeEnt = new pc.Entity();
        this._remTimeEnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [1, 0.5, 1, 0.5],
            pivot: [1, 0.5],
            fontSize: 28,
            fontAsset: Game.app.assets.find(eFontAsset.arc8UI, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
            color: new pc.Color().fromString("#ffffff")
        });
        this._remTimeEnt.setLocalPosition(-60, 0, 0);

        parent.addChild(this._remTimeEnt);

        this._remTimeSec = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this.setRemTime(Math.ceil(GameplayTimer.instance.timeLeft / 1000));
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let remTime = Math.ceil(GameplayTimer.instance.timeLeft / 1000);

        if (remTime != this._remTimeSec) {
            this.setRemTime(remTime);

            if (remTime <= 5) {
                // Blikani obrazovky
                HUD.instance.flashFx.startFx(this._flashSettings);

                // Pipani
                if (remTime > 0)
                    Game.playSound(eSfxSprite.timeTick);
            }
        }

        if (remTime <= 30)
            this._remTimeEnt.element.enabled = remTime == 0 || (Math.floor(TIMER.time / 200) & 1) != 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setRemTime(sec: number): void {
        this._remTimeSec = sec;

        // Cast s minutama
        let timeTxt = Math.floor(sec / 60).toString();

        // Cast se vterinama
        sec %= 60;

        if (sec < 10)
            timeTxt += ":0" + sec;
        else
            timeTxt += ":" + sec;

        this._remTimeEnt.element.text = timeTxt;
    }
}